import styled from "@emotion/styled/macro";
import { useMantineTheme } from "@mantine/core";
import parse from "html-react-parser";
import ms from "milsymbol";
import { replaceAt } from "../../../common/replaceAt";

interface ICustomGraphNode {
	name: string;
	symbolCode: string;
	nodeSize: { x: number; y: number };
	isRoot?: boolean;
	isRedPackage?: boolean;
	systemId?: number;
	toggleNode: () => void;
}

const CustomGraphNode: React.FC<ICustomGraphNode> = ({
	name,
	symbolCode,
	nodeSize,
	isRoot = false,
	isRedPackage,
	systemId,
	toggleNode,
}) => {
	const theme = useMantineTheme();

	var symbol = new ms.Symbol(replaceAt(symbolCode, 3, isRedPackage ? "6" : "3"), {
		size: 30,
		colorMode: "Medium",
		iconColor: {
			Hostile: theme.colorScheme === "dark" ? theme.colors.dark[2] : "black",
			Friend: theme.colorScheme === "dark" ? theme.colors.dark[2] : "black",
			Neutral: "yellow",
			Unknown: "gray",
			Civilian: "green",
		},
	}).asSVG();

	return symbol ? (
		<g>
			<foreignObject
				width={nodeSize.x}
				height={nodeSize.y}
				x={-nodeSize.x / 2}
				y={isRoot ? -50 : 0}
				style={{ textAlign: "center" }}
				onClick={() => {
					systemId && window.open(`${window.location.origin}/systems-library/systems/${systemId}`, "_blank");
				}}
			>
				<Node>
					<div onClick={() => toggleNode()}>{parse(symbol)}</div>
					{name}
				</Node>
			</foreignObject>
		</g>
	) : null;
};

export default CustomGraphNode;

const Node = styled.div`
	// padding: 2rem;
	// background-color: ${({ theme }) => (theme.colorScheme === "dark" ? theme.colors.dark[1] : theme.colors.light[1])};
`;
